export const polishPhoneRegexp: RegExp = new RegExp(/^[1-9]\d{8}$/);
